module.exports = __webpack_public_path__ + "media/assets/PrizesIcon-793937b1df2b4863019487e7d0ca0cc7.svg";